<template>
  <OnboardingInfo @next="handleClick">
    <template #heading>
      <span class="text-gray-400">Your work becomes an asset</span>
      <br />
      <span class="text-gray-800">the moment it’s registered.</span>
    </template>
    <template #body>
      Royalties. Damages. Legal remedies. Provable authorship. Every right
      copyright grants only opens once you’re on the record.
    </template>
  </OnboardingInfo>
</template>

<script setup lang="ts">
import OnboardingInfo from '@/features/onboarding/components/OnboardingInfo.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { useOnboardingStore } from '@/features/onboarding/store'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const handleClick = () => {
  completeStep({ step: 6 })

  onboardingStore.goToNextStep()
}
</script>
